import React from 'react';
import { SmileIcon, MehIcon, FrownIcon, BrainIcon, HeartIcon, LineChartIcon } from 'lucide-react';
export const MoodTracker: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-628">
      <div className="mb-6" data-id="element-629">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-630">
          Mood & Stress Tracker
        </h1>
        <p className="text-gray-600" data-id="element-631">Für dein mentales Wohlbefinden</p>
      </div>
      {/* Mood Check-in */}
      <section className="mb-8" data-id="element-632">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-633">
          Wie fühlst du dich heute?
        </h2>
        <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-634">
          <div className="flex justify-between mb-6" data-id="element-635">
            <button className="flex flex-col items-center" data-id="element-636">
              <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-2" data-id="element-637">
                <FrownIcon size={32} className="text-red-600" data-id="element-638" />
              </div>
              <span className="text-sm text-gray-700" data-id="element-639">Schlecht</span>
            </button>
            <button className="flex flex-col items-center" data-id="element-640">
              <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mb-2" data-id="element-641">
                <MehIcon size={32} className="text-orange-600" data-id="element-642" />
              </div>
              <span className="text-sm text-gray-700" data-id="element-643">Okay</span>
            </button>
            <button className="flex flex-col items-center" data-id="element-644">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-2 ring-2 ring-green-300" data-id="element-645">
                <SmileIcon size={32} className="text-green-600" data-id="element-646" />
              </div>
              <span className="text-sm text-gray-700" data-id="element-647">Gut</span>
            </button>
            <button className="flex flex-col items-center" data-id="element-648">
              <div className="w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center mb-2" data-id="element-649">
                <SmileIcon size={32} className="text-purple-600" data-id="element-650" />
              </div>
              <span className="text-sm text-gray-700" data-id="element-651">Großartig</span>
            </button>
          </div>
          <div data-id="element-652">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-653">
              Notizen (optional)
            </label>
            <textarea className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" placeholder="Wie fühlst du dich genau? Was hat dazu beigetragen?" rows={3} data-id="element-654"></textarea>
          </div>
          <button className="mt-4 bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium w-full" data-id="element-655">
            Speichern
          </button>
        </div>
      </section>
      {/* Mood Analysis */}
      <section className="mb-8" data-id="element-656">
        <div className="flex justify-between items-center mb-4" data-id="element-657">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-658">
            Stimmungsanalyse
          </h2>
          <div className="flex space-x-2" data-id="element-659">
            <button className="text-purple-600 text-sm font-medium bg-purple-100 px-2 py-1 rounded" data-id="element-660">
              Woche
            </button>
            <button className="text-gray-600 text-sm font-medium bg-gray-100 px-2 py-1 rounded" data-id="element-661">
              Monat
            </button>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-662">
          <div className="flex justify-between items-center mb-4" data-id="element-663">
            <div data-id="element-664">
              <p className="text-sm text-gray-500" data-id="element-665">
                Durchschnittliche Stimmung
              </p>
              <div className="flex items-center" data-id="element-666">
                <SmileIcon size={20} className="text-green-600 mr-1" data-id="element-667" />
                <p className="font-semibold text-gray-800" data-id="element-668">Gut</p>
              </div>
            </div>
            <div data-id="element-669">
              <p className="text-sm text-gray-500" data-id="element-670">Stimmungsschwankungen</p>
              <p className="font-semibold text-gray-800" data-id="element-671">Minimal</p>
            </div>
            <div data-id="element-672">
              <p className="text-sm text-gray-500" data-id="element-673">Stress-Level</p>
              <p className="font-semibold text-gray-800" data-id="element-674">Niedrig</p>
            </div>
          </div>
          <div className="h-40 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-675">
            <p className="text-gray-400" data-id="element-676">Stimmungsverlauf-Diagramm</p>
          </div>
          <div className="mt-4" data-id="element-677">
            <p className="text-sm font-medium text-gray-700 mb-2" data-id="element-678">
              KI-Analyse:
            </p>
            <p className="text-sm text-gray-600" data-id="element-679">
              Deine Stimmung ist in den letzten 7 Tagen stabil und überwiegend
              positiv. An Tagen mit mehr Bewegung und besserem Schlaf ist deine
              Stimmung tendenziell besser.
            </p>
          </div>
        </div>
      </section>
      {/* Correlations */}
      <section className="mb-8" data-id="element-680">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-681">
          Zusammenhänge erkannt
        </h2>
        <div className="space-y-4" data-id="element-682">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-683">
            <div className="flex items-center mb-3" data-id="element-684">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-685">
                <HeartIcon size={20} className="text-blue-600" data-id="element-686" />
              </div>
              <div data-id="element-687">
                <p className="font-medium text-gray-800" data-id="element-688">HRV & Stimmung</p>
                <div className="flex items-center mt-1" data-id="element-689">
                  <LineChartIcon size={14} className="text-green-500 mr-1" data-id="element-690" />
                  <p className="text-xs text-gray-500" data-id="element-691">
                    Starke positive Korrelation
                  </p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-692">
              An Tagen mit höherer Herzfrequenzvariabilität ist deine Stimmung
              tendenziell besser.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-693">
            <div className="flex items-center mb-3" data-id="element-694">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-695">
                <BrainIcon size={20} className="text-purple-600" data-id="element-696" />
              </div>
              <div data-id="element-697">
                <p className="font-medium text-gray-800" data-id="element-698">Schlaf & Stress</p>
                <div className="flex items-center mt-1" data-id="element-699">
                  <LineChartIcon size={14} className="text-red-500 mr-1" data-id="element-700" />
                  <p className="text-xs text-gray-500" data-id="element-701">
                    Starke negative Korrelation
                  </p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-702">
              Nach Nächten mit weniger als 7 Stunden Schlaf ist dein Stresslevel
              deutlich höher.
            </p>
          </div>
        </div>
      </section>
      {/* Recommendations */}
      <section data-id="element-703">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-704">
          Empfehlungen für dich
        </h2>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-705">
          <div className="p-4 border-b border-gray-100" data-id="element-706">
            <div className="flex items-center" data-id="element-707">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-708">
                <SmileIcon size={20} className="text-green-600" data-id="element-709" />
              </div>
              <div className="flex-1" data-id="element-710">
                <p className="font-medium text-gray-800" data-id="element-711">
                  10-Minuten Meditation
                </p>
                <p className="text-sm text-gray-500" data-id="element-712">Für mehr innere Ruhe</p>
              </div>
              <button className="ml-4 bg-green-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-713">
                Starten
              </button>
            </div>
          </div>
          <div className="p-4 border-b border-gray-100" data-id="element-714">
            <div className="flex items-center" data-id="element-715">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-716">
                <HeartIcon size={20} className="text-blue-600" data-id="element-717" />
              </div>
              <div className="flex-1" data-id="element-718">
                <p className="font-medium text-gray-800" data-id="element-719">Atemübung</p>
                <p className="text-sm text-gray-500" data-id="element-720">
                  4-7-8 Technik für Stressreduktion
                </p>
              </div>
              <button className="ml-4 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-721">
                Starten
              </button>
            </div>
          </div>
          <div className="p-4" data-id="element-722">
            <div className="flex items-center" data-id="element-723">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-724">
                <BrainIcon size={20} className="text-purple-600" data-id="element-725" />
              </div>
              <div className="flex-1" data-id="element-726">
                <p className="font-medium text-gray-800" data-id="element-727">Naturspaziergang</p>
                <p className="text-sm text-gray-500" data-id="element-728">20 Minuten im Grünen</p>
              </div>
              <button className="ml-4 bg-purple-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-729">
                Erinnern
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};